// Main navigation
function mainNavigation() {

  var $headerWrap = $('.header-wrap'),
      $sublink1 = $('.menu-main__sublink-1'),
      $sublink2 = $('.menu-main__sublink-2'),
      $menuLevel2Holder = $('.menu-main__level-2-holder'),
      $menuLevel3 = $('.menu-main__level-3'),
      $backing = $('.header-wrap .backing');

  // Action for menu level 2
  $sublink1.on('click', function (e) {
    e.preventDefault();

        if (!$(this).hasClass('active')) {
            openSubnav1(this);
        } else {
            closeSubnav1(this);
        }

        if (window.matchMedia('(min-width: 1279px)').matches) {
            if ($menuLevel2Holder.hasClass('show')) {
                $headerWrap.addClass('show-level-2');
            } else {
                $headerWrap.removeClass('show-level-2');
            }
        }
    });

    if (window.matchMedia('(min-width: 1279px)').matches) {
        console.log( $sublink1.parent('li') );
        $sublink1.parent('li').on("hover", function (e) {
            if (e.type == "mouseenter") { //mouseenter
               openSubnav1(this.querySelector('a'));
               $headerWrap.addClass('show-level-2');
            } else { // mouseleave
               closeSubnav1(this.querySelector('a'));
               $headerWrap.removeClass('show-level-2');
            }
        });
    }

    function openSubnav1(context) {
        $menuLevel2Holder.slideUp(1).removeClass('show');
        $sublink1.removeClass('active');
        $(context).addClass('active');
        $(context).next().slideDown(100).addClass('show');
        $backing.slideDown(1);
    }

    function closeSubnav1(context) {
        $(context).removeClass('active');
        $(context).next().slideUp(1).removeClass('show');
        $backing.slideUp(1);
    }

// Closing for menu main level 2
    $('.menu-main__closer, .overlay-level-2').on('click', function () {
        $menuLevel2Holder.slideUp(1).removeClass('show');
        $headerWrap.removeClass('show-level-2');
        $sublink1.removeClass('active');

    $menuLevel3.hide(1);
    $sublink2.removeClass('active');
    $backing.slideUp(1);
  });

  // Closin for menu main level-2 after resize
  $(window).on('resize', function () {
    if(window.matchMedia('(min-width: 1280px)').matches) {
      if($('.menu-main__level-2-holder').hasClass('show')) {
        $backing.slideDown(1);
      }
    }
  });

  // Action for menu level 3
  $sublink2.on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('active')) {
      $menuLevel3.hide(1);
      $sublink2.removeClass('active');
      $(this).addClass('active');
      $(this).next().show(1).css('display', 'flex');
    } else {
      $(this).removeClass('active');
      $(this).next().hide(1);
    }
  });

  $('.return-btn').on('click', function () {
    $menuLevel3.hide(1);
  });

  // Show-hide 'menu-main' on tablet and mobile
  $('.burger-btn').on('click', function () {
    $(this).toggleClass('active');
    $('#page').toggleClass('menu-show');
    $('.menu-main').fadeToggle(200);

    $sublink1.removeClass('active');
    $sublink2.removeClass('active');
    $('.menu-main__level-2-holder, .menu-main__level-3').slideUp(1).removeClass('show');
    $('.menu-main__level-2-holder').removeClass('show');
    $backing.css({
      display: 'none',
      overflow: 'visible'
    });
  });

  // Closing for menu main level 1 and inside elements
  $('.overlay-level-1').on('click', function () {
    $('.burger-btn').removeClass('active');
    $('#page').removeClass('menu-show');
    $('.menu-main').slideUp(1);
    $('.menu-main__level-2-holder').removeClass('show');
    $backing.css({
      display: 'none',
      overflow: 'visible'
    });
  });

  // Adding class '.penultimate' in last child of '.menu-main'
  $('#menu-main .search-holder').prev().addClass('penultimate');
}
